import * as React from "react";
import { ButtonPrimary, ButtonSecondary, ButtonGhost, ButtonOutline } from "@grandvisionhq/iris-ui";
import "../../../../events/events/event-properties-provider.js";
import { useDispatchTrackClickEvent } from "../../../../events/events/use-track-click-event.js";
const TealiumIrisUIButton = React.forwardRef(
  ({ tealiumEvent, ...props }, ref) => {
    const { onPress, variant, ...restProps } = props;
    const dispatchTrackClickEvent = useDispatchTrackClickEvent();
    const handleClick = (event) => {
      if (tealiumEvent) {
        try {
          dispatchTrackClickEvent({
            ...tealiumEvent,
            Tracking_Type: "link"
          });
        } catch (error) {
          console.error("Tealium dispatch error:", error);
        }
      }
      if (onPress) {
        onPress(event);
      }
    };
    switch (variant) {
      case "outline":
        return /* @__PURE__ */ React.createElement(ButtonOutline, { ...restProps, onPress: handleClick, ref });
      case "ghost":
        return /* @__PURE__ */ React.createElement(ButtonGhost, { ...restProps, onPress: handleClick, ref });
      case "secondary":
        return /* @__PURE__ */ React.createElement(ButtonSecondary, { ...restProps, onPress: handleClick, ref });
      case "primary":
      default:
        return /* @__PURE__ */ React.createElement(ButtonPrimary, { ...restProps, onPress: handleClick, ref });
    }
  }
);
TealiumIrisUIButton.displayName = "TealiumIrisUIButton";
export {
  TealiumIrisUIButton
};
//# sourceMappingURL=TealiumIrisUIButton.js.map
